export const SET_SCHOOLS = 'SET_SCHOOLS'

export const setSchools = data => async dispatch => {
  dispatch({
    type: SET_SCHOOLS,
    payload: data
  })
}